<template>
  <div class="search">
    <Row>
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="4" style="padding-right:10px">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
        <Col span="4">
          <Button
            type="primary"
            v-hasPermission="['network:cenMonitor:page']"
            @click="getData"
            >{{ $t("message.select") }}</Button
          >
        </Col>
      </div>
    </Row>
  </div>
</template>
<script>
import TableCen from "../cen/TableCen";
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
var tableCen = TableCen;
export default {
  name: "CenSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      stateSearchKey: []
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      tableCen.methods.showAll();
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    }
  }
};
</script>
<style scoped>
.search {
  height: 51px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/network/cen/CenSearch.vue